export const defaultColor = '#424F76'

export const originColor = '#784a81'
export const itemCollectionColor = '#946299'
export const itemColor = '#c09ec4'

export const contentAnalysisColor = '#4f4276'

export const originalTitleColor = '#b4515e'
export const titleColor = '#da5e67'
export const creditColor = '#ef9fae'

export const customerColor = '#cdc85c'
